import React from 'react';
import { Grid } from '@mui/material';

import { Icon, useSettings } from 'app/main/components';
import {
	DetailsSectionDescription,
	DetailsSectionInfoWrapper,
	type DetailsPageContentProps
} from 'app/main/components/page-layouts';
import DetailsSectionNotes from 'app/main/submodules/notes/DetailsSectionNotes';

import SkillsDetailsSectionInfo from '../sections/SkillsDetailsSectionInfo';
import SkillsDetailsSectionSecondaryInfo from '../sections/SkillsDetailsSectionSecondaryInfo';

export default function SkillsDetailsTab(props: DetailsPageContentProps) {
	const { t } = useSettings();

	return (
		<Grid container spacing={2}>
			<Grid size={{ lg: 8, xs: 12 }}>
				<Grid container spacing={2}>
					<Grid size={12}>
						<DetailsSectionInfoWrapper
							avatar={<Icon icon="text-subject" />}
							title={t('DETAILS_INFO_SECTION')}
							subheader={t('DETAILS_INFO_SUBHEADER')}
						>
							<SkillsDetailsSectionInfo
								model={props.model}
								sendChange={props.sendChange}
								isEdit={props.isEdit}
								logProps={props.logProps}
							/>
						</DetailsSectionInfoWrapper>
					</Grid>
					<Grid size={12}>
						<DetailsSectionDescription
							name="skll_descriptionhtml"
							value={props.model.skll_descriptionhtml}
							isEdit={props.isEdit}
							sendChange={props.sendChange}
							logProps={props.logProps}
						/>
					</Grid>
					<Grid size={12}>
						<DetailsSectionNotes module="skills" uid={props.model.skll_uid} />
					</Grid>
				</Grid>
			</Grid>
			<Grid size={{ lg: 4, xs: 12 }}>
				<Grid container spacing={2}>
					<Grid size={12}>
						<DetailsSectionInfoWrapper
							avatar={<Icon icon="text-subject" />}
							title={t('DETAILS_SECONDARY_INFO_SECTION')}
							subheader={t('DETAILS_SECONDARY_INFO_SUBHEADER')}
						>
							<SkillsDetailsSectionSecondaryInfo
								model={props.model}
								sendChange={props.sendChange}
								isEdit={props.isEdit}
								logProps={props.logProps}
							/>
						</DetailsSectionInfoWrapper>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
}
